import SlideInWrapper from './SlideInWrapper';

export default SlideInWrapper;
